import React from 'react';
import EasyCropComponent from './EasyCropFiles';
import Image_uploader from "../../assets/img/img_upload/upload.svg";
import $ from "jquery";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";

const Compress = require('compress.js');


function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}

// function getBase64(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//   });
// }


class App extends React.Component {
  state = {
    isCrop: false,

    imageSrc: "",
    imagePreview: "",
    imagebase64: "",

    crop: { x: 0, y: 0 },
    zoom: 1,
  }

   blobToBase64 = blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  onFileChange = async e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let imageDataUrl = await readFile(file)
      this.setState({
        imageSrc: imageDataUrl,
        crop: { x: 0, y: 0 },
        zoom: 1,

        isCrop: true

      });
    }
  };

  parentMethod = (src, b, file) => {
    this.setState({
      imagePreview: src,
    });

    //-- please don't delete following commented code --

    // this.blobToBase64(src).then(res => {
    //   // do what you wanna do
    //   this.setState({imagebase64: res});
    //   this.props.getImage(b, this.state.imagebase64);
    //   var image = new Image();
    //   image.src = this.state.imagebase64;
    //   this.setState({
    //     imageSrc: ""
    //   });
    //   $(".fileInput").val("");
    // });


    let compress = new Compress();

    const files = [];
    files.push(file);
    this.props.spinnerHandler(true);
    compress.compress(files, {
      size: 4, // the max size in MB, defaults to 2MB
      quality: .25, // the quality of the image, max is 1,
      maxWidth: 1920, // the max width of the output image, defaults to 1920px
      maxHeight: 1920, // the max height of the output image, defaults to 1920px
      resize: true, // defaults to true, set false if you do not want to resize the image width and height
    }).then((data) => {
      // returns an array of compressed images
      this.setState({imagebase64: data[0].prefix + data[0].data});
      this.props.getImage(b, this.state.imagebase64);
      var image = new Image();
      image.src = this.state.imagebase64;
      this.setState({
        imageSrc: ""
      });
      $(".fileInput").val("");
    }).finally(fin => {
      this.props.spinnerHandler(false);
    });

  };

  closeModal = () => {
    this.setState({isCrop: false});
    // document.body.className = 'header-fixed sidebar-lg-show sidebar-fixed modal-open';
    // $("body").addClass("modal-open");
  };


  render() {

    let {imageSrc} = this.state;
    let $imagePreview = null;
    // if ((this.props.image.trim() !== '' && this.state.imageSrc.trim() !== '') || (this.props.image.trim() === '' && this.state.imageSrc.trim() !== '')) {
    if ((this.props.image) !== '') {
      $imagePreview = (<img src={this.props.image} style={{
        width: '200px',
        height: '200px',
        objectFit: 'scale-down',
        border: '1px #9a9a9a dotted',
        cursor: 'pointer'
      }}/>);

    } else {
      $imagePreview = (<div className="previewText"
                            style={this.props.image ? isImage : isNotImage}
      >
        {/*<img style={this.props.image.trim() !== "" ? isImageTag : isNotImageTag}*/}
             {/*src={this.props.image.trim() !== "" ? this.props.image : Image_uploader}/>*/}

             <img style={ isNotImageTag }
             src={ Image_uploader}/>
      </div>);
    }

    let wh = false;

    return(


      <div>

        {
          this.state.isCrop ?
            <EasyCropComponent parentMethod = {this.parentMethod} imageDataUrl={this.state.imageSrc} closeModal={this.closeModal}/>:null
        }

        <div style={this.state.isCrop?nonedisplayclass:displayclass}>

          {/*<form onSubmit={(e) => this._handleSubmit(e)}>*/}
          <form>
          <input
            className="fileInput"
            id={this.props.propName}
            type="file"
            multiple accept='image/jpeg, image/jpg, image/png'
            style={{
              display: 'none',
              cursor: 'pointer',
              zIndex: '1',
              position: 'absolute',
              marginTop: '0%',
              opacity: '0',
              width: '200px',
              height: '200px',
            }}
            onChange={this.onFileChange}
          />

          </form>
          <label htmlFor={this.props.propName} className="imgPreview" style={{
            textAlign: 'center',
            boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.1)',
            backgroundColor: this.props.white ? '#00ff51' : '#414141',
            background: 'transparent',
            width: '200px',
            height: '200px',

          }}>

            {$imagePreview}

          </label>

        </div>


      </div>


    );

  }

}

let displayclass = {
  display: 'block'
};

let nonedisplayclass = {
  display: 'none'
};

let isImageTag = {
  height: '200px',
  width: '200px',
  objectFit: 'contain'
};

let isNotImageTag = {
  height: '45%',
};


let isImage = {
  width: '200px',
  height: '200px',
  color: 'white',
  border: '1px #9a9a9a dotted',
  cursor: 'pointer'
};
let isNotImage = {
  width: '200px',
  height: '200px',
  color: 'white',
  paddingTop: '30%',
  border: '1px #9a9a9a dotted',
  cursor: 'pointer'
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

